// extracted by mini-css-extract-plugin
export default {"borderBottom":"Category_borderBottom__fMfXJ","gridContainer":"Category_gridContainer__Fsq3O"};